/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const PermissionEnum = {
    AddWorkspace: 'add-workspace',
    AuthorisePayouts: 'authorise-payouts',
    ApproveMemberships: 'approve-memberships',
    CreateTasks: 'create-tasks',
    ChangeNameOfLegalEntity: 'change-name-of-legal-entity',
    DeactivateClients: 'deactivate-clients',
    DeactivateUser: 'deactivate-user',
    DeactivateWorkspace: 'deactivate-workspace',
    DeleteBankDetails: 'delete-bank-details',
    DeleteBeneficiaries: 'delete-beneficiaries',
    DeleteCascades: 'delete-cascades',
    DeleteDocuments: 'delete-documents',
    DeleteMemberships: 'delete-memberships',
    DeletePermissions: 'delete-permissions',
    DeleteServices: 'delete-services',
    DeleteTitles: 'delete-titles',
    DeleteUsers: 'delete-users',
    DeleteTasks: 'delete-tasks',
    EditAllowPayments: 'edit-allow-payments',
    EditBankDetails: 'edit-bank-details',
    EditBeneficiaries: 'edit-beneficiaries',
    EditCascades: 'edit-cascades',
    EditClients: 'edit-clients',
    EditDocuments: 'edit-documents',
    EditMemberships: 'edit-memberships',
    EditNotificationPreferences: 'edit-notification-preferences',
    EditPermissions: 'edit-permissions',
    EditProfile: 'edit-profile',
    EditSearchIndexes: 'edit-search-indexes',
    EditServices: 'edit-services',
    EditSettings: 'edit-settings',
    EditTeammates: 'edit-teammates',
    EditTitles: 'edit-titles',
    EditUsers: 'edit-users',
    EditWorkspace: 'edit-workspace',
    EditWorkspaceDetails: 'edit-workspace-details',
    EditTasks: 'edit-tasks',
    EnableNewServices: 'enable-new-services',
    InitiatePayouts: 'initiate-payouts',
    InviteUser: 'invite-user',
    LeaveWorkspace: 'leave-workspace',
    MigrateBankDetails: 'migrate-bank-details',
    NotifyPaymentStatementAvailable: 'notify-payment-statement-available',
    ReviewMemberships: 'review-memberships',
    SendMembershipApplications: 'send-membership-applications',
    SetWorkspaceAsAgent: 'set-workspace-as-agent',
    TransferWorkspaceOwnership: 'transfer-workspace-ownership',
    VerifyClientRepresentation: 'verify-client-representation',
    ViewActivities: 'view-activities',
    ViewBalances: 'view-balances',
    ViewBankDetails: 'view-bank-details',
    ViewBeneficiaries: 'view-beneficiaries',
    ViewCascades: 'view-cascades',
    ViewClients: 'view-clients',
    ViewDocuments: 'view-documents',
    ViewManageWorkspace: 'view-manage-workspace',
    ViewMemberships: 'view-memberships',
    ViewNotificationFeed: 'view-notification-feed',
    ViewOnboarding: 'view-onboarding',
    ViewPaymentStatements: 'view-payment-statements',
    ViewPayouts: 'view-payouts',
    ViewPermissions: 'view-permissions',
    ViewServices: 'view-services',
    ViewStaffHomepage: 'view-staff-homepage',
    ViewTasks: 'view-tasks',
    ViewTeammates: 'view-teammates',
    ViewTitles: 'view-titles',
    ViewTransactions: 'view-transactions',
    ViewUsers: 'view-users',
    ViewWorkspace: 'view-workspace',
    ViewWorkspaceActivities: 'view-workspace-activities',
};
